import Register from "./pages/teachers-registration/TeachersRegistrationForm";
import Confirm from "./pages/teachers-registration/Confirm";
import { iRoute } from "./types/iRoute";

const routes: iRoute[] = [
  { path: "/", exact: true, name: "register", element: Register },
  { path: "/register", name: "register", element: Register },
  { path: "/confirm", name: "confirm", element: Confirm },
];

export default routes;
